<template>
  <div>
    <table class="table table-responsive">
      <tbody>
        <tr v-if="status">
          <th style="border-top: none">Status</th>
          <td style="border-top: none">
            <EpcStatus :status="status" />
          </td>
        </tr>
        <tr>
          <th>{{ $t('name') }}</th>
          <td>
            {{
              saveGet(
                mobilePhysicalLocation,
                '-',
                'physicalLocationName',
                0,
                'value'
              )
            }}
          </td>
        </tr>
        <tr>
          <th>{{ $t('base_location') }}</th>
          <td>
            <span>
              {{ glnType }}
              <br />
              {{ saveGet(mobilePhysicalLocation, '-', 'baseLocation', 'gln') }}
            </span>
          </td>
        </tr>
        <tr>
          <th>{{ $t('role') }}</th>
          <td>
            <ul style="padding-left: 0" id="v-roles-list">
              <p v-for="role in roles" :key="role">
                {{ $t(`locationType.${role}_title`) }}
              </p>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{ $t('more_locations') }}</th>
          <td>
            <template
              v-if="additionalIDs instanceof Array && additionalIDs.length > 0"
            >
              <p
                v-for="additionalID in additionalIDs"
                :key="additionalID.toString() + Math.random()"
              >
                {{
                  $t(`locationIdType.${additionalID.locationID_Type}_title`)
                }}:
                {{ additionalID.locationID }}
              </p>
            </template>
            <template v-else> - </template>
          </td>
        </tr>
        <tr>
          <th>{{ $t('contact') }}</th>
          <td style="border-bottom: 0">
            <Contact
              :contact="
                saveGet(mobilePhysicalLocation, null, 'contactPoint', 0)
              "
            />
          </td>
        </tr>
        <links-tr :linkSet="linkSet">{{ $t('targets') }}</links-tr>
        <tr>
          <th>{{ $t('last_update') }}</th>
          <td style="border-bottom: none">{{ dateUpdated }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { saveGet } from '../mixins/saveGet'
import Address from './Address'
import Contact from './Contact'
import moment from 'moment/moment'
import EpcStatus from './EpcStatus.vue'
import LinksTr from '@/components/LinksTr.vue'

export default {
  name: 'MobilePhysicalLocation',
  props: ['mobilePhysicalLocation', 'status', 'linkSet'],
  components: {
    EpcStatus,
    Contact,
    Address,
    LinksTr
  },
  mixins: [saveGet],
  computed: {
    additionalIDs() {
      return this.saveGetAndMap(
        this.mobilePhysicalLocation,
        null,
        arr => arr.filter(x => x),
        'additionalLocationID'
      )
    },
    glnType() {
      return this.saveGetAndMap(
        this.mobilePhysicalLocation,
        '-',
        baseLocationglnType =>
          this.$t('glnType.' + baseLocationglnType + '_text'),
        'baseLocation',
        'glnType'
      )
    },
    roles() {
      return this.saveGetAndMap(
        this.mobilePhysicalLocation,
        '-',
        arr => arr.filter(x => x),
        'locationRole'
      )
    },
    dateUpdated() {
      let updated = this.saveGet(this.mobilePhysicalLocation, '', 'dateUpdated')
      if (!updated) {
        return '-'
      }

      return moment(updated).format('DD. MMM YYYY')
    }
  },
  i18n: {
    messages: {
      de: {
        name: 'Name',
        role: 'Lokationsrolle',
        base_location: 'Basisstandort',
        contact: 'Kontakt',
        last_update: 'Zuletzt geändert',
        more_locations: 'Weitere Lokation-IDs',
        targets: 'Lokationsbezogene Verlinkungen'
      },
      en: {
        name: 'Name',
        role: 'Location role',
        base_location: ' Base location',
        contact: 'Contact',
        last_update: 'Last update',
        more_locations: 'Additional location-IDs',
        targets: 'Location related links'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MobilePhysicalLocation.vue